import { api } from '@services';

import Product, { IProduct, IProductApiModel } from '@models/Product.model';

const indexResourceProducts = async (id?: string): Promise<IProduct[]> => {
  const { data: products } = await api.get<IProductApiModel[]>(
    `/resources/${id}/products`,
  );

  return Product.arrayFromApiModel(products);
};

export { indexResourceProducts };
